import * as fromTrainingLevel from './trainingLevel.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';

const { selectAll } = fromTrainingLevel.trainingLevelAdapter.getSelectors();

export const selectTrainingLevelState = createFeatureSelector<fromTrainingLevel.State>(fromTrainingLevel.trainingLevelFeatureKey);

export const selectAllTrainingLevels = createSelector(selectTrainingLevelState, selectAll);

export const selectTrainingLevelsByName = (searchString: string) =>
    createSelector(selectAllTrainingLevels, (entities) => entities.filter((entity) => entity.name?.toLowerCase().includes(searchString.toLowerCase())));
